import type { ComponentType } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import ReactTooltip from 'react-tooltip';
import { BiSync } from 'react-icons/bi';

import theme from 'styles/theme';

const RouterLinkComponent = RouterLink as ComponentType<LinkProps>;

const shouldForwardProp = (prop: string) => !prop.startsWith('$');

const modalHeadingColor = '#000000';

export const pixTooltipBackground = '#97f8fb';
export const pixTooltipColor = '#0b29fb';

export const ReactTooltipPix = styled(ReactTooltip)``;

export const Container = styled.div`
  background-color: white;
  border-radius: 10px;
  width: auto;
  height: auto;
  padding: 25px;
  overflow-x: hidden;
  font-family: 'Mangueira', sans-serif;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: ${modalHeadingColor};
`;

export const BackButton = styled.span`
  font-size: 1.25rem;
  color: ${modalHeadingColor};
  margin-right: 10px;
  margin-left: -3px;
  cursor: pointer;
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: ${modalHeadingColor};
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
`;

export const CustomerInfoContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 25px;
  padding-bottom: 14px;
`;

export const Info = styled('div', { shouldForwardProp })<{ $spaced?: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 116px;

  ${({ $spaced }) =>
    $spaced &&
    css`
      margin-top: 10px;
    `}
`;

export const InfoTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  height: 23px;
  color: ${modalHeadingColor};
`;

export const InfoText = styled.span`
  color: ${theme.colors.primaryText};
  font-family: 'Mangueira', sans-serif;
  font-size: 13px;
  height: 23px;

  @media (max-width: 460px) {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const InfoTextPix = styled(InfoText)`
  max-width: 256px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Hr = styled.hr`
  border-top: 1px dashed ${theme.colors.lightGray};
  margin: 0;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 17px;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;
  margin-top: 10px;

  @media (min-width: 992px) {
    flex-wrap: wrap;
  }
`;

export const SectionTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: bold;
  color: ${modalHeadingColor};
  font-size: 20px;
`;

export const Link = styled(RouterLinkComponent)`
  text-decoration: none !important;
  color: ${theme.colors.primaryText};
  font-size: 13px;
  height: 23px;
`;

export const InvoiceNumber = styled('span', { shouldForwardProp })<{
  $mi?: boolean;
}>`
  color: ${theme.colors.primaryText};
  font-family: 'Mangueira', sans-serif;
  font-size: 13px;
  height: 23px;
  text-decoration: ${({ $mi }) => ($mi ? 'none' : 'underline')};
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StatusIcon = styled('div', { shouldForwardProp })<{
  $color?: string;
}>`
  background-color: ${({ $color }) => $color};
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 10px;
`;

export const StatusText = styled.span`
  color: ${theme.colors.primaryText};
  font-family: 'Mangueira', sans-serif;
  font-size: 15px;
`;

export const BankSlipContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 20px;
  margin-bottom: 10px;
`;

export const TypeableLineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TypeableLineIcon = styled.i`
  font-size: 20px;
  font-weight: bold;
  margin-left: 5px;
  color: #000000;
`;

export const ToolTipText = styled.span``;

export const ToolTipButton = styled.a`
  cursor: pointer;
`;

export const BarcodeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;

export const BarcodeContent = styled.div`
  margin-left: -9px !important;
  margin-top: -2px;

  @media (max-width: 467px) {
    display: none;
  }
`;

export const BarcodeResponsive = styled.div`
  display: none;

  @media (max-width: 467px) {
    margin-left: -9px !important;
    display: flex;
  }
`;

export const BarcodeFullWidth = styled.div`
  width: 100%;

  svg {
    width: 100%;
  }
`;

export const PixSyncIcon = styled(BiSync)`
  cursor: pointer;
  color: ${theme.colors.blue};
`;

export const RemoveSpace = styled.div`
  margin-bottom: -15px;
`;

export const PaymentInfos = styled.div``;

export const PaymentWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const UpdatePixContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const MobileInfoTooltipWrap = styled.div``;

export const MobileInfoTooltipContainer = styled.div`
  width: max-content;
  height: max-content;
  background: ${pixTooltipBackground};
  padding: 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
`;

export const MobileInfoTooltipTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: ${pixTooltipColor};
  text-align: initial;
  display: block;
  margin-bottom: 5px;
`;

export const MobileInfoTooltipText = styled.div`
  color: ${pixTooltipColor};
`;
